import { Dictionary } from '../types/Dictionary';

import { BasePage } from '../pages/base-page';
import { ApartmentDetailPage } from '../pages/apartment-detail/apartment-detail';
import { ApartmentsLocationsPage } from '../pages/apartments-locations/apartments-locations';
import { ApartmentSearchPage } from '../pages/apartment-search/apartment-search';
import { ApartmentsOverviewPage } from '../pages/apartments-overview/apartments-overview';
import { ApartmentLocationPage } from '../pages/apartment-location/apartment-location';
import { HomepagePage } from '../pages/homepage/homepage';
import { FavoriteProductsPage } from '../pages/favorite-products/favorite-products';
import { EmptyPageWithLayout } from '../pages/empty-page-with-layout/empty-page-with-layout';
import { EmptyPage } from '../pages/empty-page/empty-page';
import { EmptyPageWithoutLayout } from '../pages/empty-page-without-layout/empty-page-without-layout';

export const pageComponentsByKey: Dictionary<typeof BasePage> = {
	'apartment-detail': ApartmentDetailPage,
	'apartments-locations': ApartmentsLocationsPage,
	'apartment-search': ApartmentSearchPage,
	'apartments-overview': ApartmentsOverviewPage,
	'apartment-location': ApartmentLocationPage,
	'homepage': HomepagePage,
	'favorite-products': FavoriteProductsPage,
	'empty-page-with-layout': EmptyPageWithLayout,
	'empty-page': EmptyPage,
	'empty-page-without-layout': EmptyPageWithoutLayout
};
